import { useEffect, useState } from 'react'
import styles from './InputFile.module.scss'
import ImagePreview from './ImagePreview'
import {InputFileSVG} from '../../svg/icons/InputFileSVG'
import { useTranslation } from 'react-i18next';

interface Image {
    src: string;
    loading: boolean;
}

export const InputFile = ({setIsDisabledFiles}: any) => {

    const [filesLength, setFilesLength] = useState<number>(0)
    const [images, setImages] = useState<Image[]>([])
    const [loadingIndex, setLoadingIndex] = useState<number>(0);

    const {t} = useTranslation()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || !e.target.files[0]) {
            return;
        }
        const fullFilesLength = filesLength + e.target.files.length
        if (fullFilesLength > 3) {
            alert('A maximum of 3 files are allowed');
            return;
        }
        setFilesLength(fullFilesLength)
        const files = Array.from(e.target.files);

        files.map((file, index) => {
            setImages((prev)=>[
            ...prev,
            {
                src: URL.createObjectURL(file),
                loading: true,
            }
        ])});
        setLoadingIndex(0)
    }

    const handleDeleteImage = (src: string) => {
        setFilesLength(filesLength-1)
        setImages(Array.from(images).filter((image: Image) => image.src !== src))
    };

    useEffect(() => {
        if(images.length === 0){
            setIsDisabledFiles(true)
        }
        else{
            setIsDisabledFiles(false)
        }
        const interval = setInterval(() => {
          if (loadingIndex < images.length) {
            const newImages = [...images];
            newImages[loadingIndex].loading = false;
            setImages(newImages);
            setLoadingIndex((prevIndex) => prevIndex + 1);
          } else {
            clearInterval(interval);
          }
        }, 1000);

        return () => clearInterval(interval);

      }, [loadingIndex, images]);

    return (
    <>
        <div className={styles.inputFileContainer}>
            {filesLength < 3 
            ? 
            <label htmlFor="file-drop" className={filesLength > 0 ? styles.dropWrapperWithImages : styles.dropWrapper}>
                <InputFileSVG className={styles.dropSVG} width='16' height='18'/>
                {filesLength === 0 && <span className={styles.dropTitle}>{t("Прикрепить файл")}</span>}
                <input type="file" id="file-drop" className={styles.dropInput} required multiple onChange={(e)=>handleChange(e)}/>
            </label>
            : <></>
            }
            {filesLength > 0 && 
            <div className={styles.inputFileImage}>
                {images.map((image) => {
                    return(
                        <ImagePreview image={image} onDelete={handleDeleteImage} />
                    )
                })}
            </div>
            }
        </div>
    </>
  )
}